module.exports = __webpack_public_path__ + "static/media/festivities.96d995b6.svg";